import React, {memo} from 'react';
import Box from '@material-ui/core/Box';

import PerformanceWidget from '../../components/v2/sections/fortnite-games/performance/PerformanceWidget';
import useGamesData from './useGamesData';

import {ChartContainer} from './FortniteGames.styles';

const Performance = () => {
    const {
        data: {codeNamesMap, recentGamesOptions},
        loading: gamesLoading
    } = useGamesData();

    return (
        <Box marginTop={10}>
            <ChartContainer>
                <PerformanceWidget
                    selectedGames={recentGamesOptions.slice(0, 1)}
                    gamesList={recentGamesOptions}
                    keysMap={codeNamesMap}
                    gamesLoading={gamesLoading}
                />
            </ChartContainer>
        </Box>
    );
};

export default memo(Performance);
